<template>
  <div class="not-found-page fill-space">
    <p class="lead text-center center-center"><router-link :to="sessionUserHomePage">Page Not Found<br/>Return to Dashboard</router-link></p>
  </div>
</template>

<script>
export default {
  name: 'NotFound',
  computed: {
    sessionUserHomePage () {
      return this.$store.getters.sessionUserHomePage
    }
  }
}
</script>
